import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SharedConnectionsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.SharedConnectionsFilters>;
}>;


export type SharedConnectionsQuery = { sharedConnections: { active?: { edges?: Array<{ node: { workspaceId: string, workspaceName: string, workspaceLogo: string, icon?: string | null, workspaceURI: string, connectedAt?: string | null, connectionId: string, sharedItemsCount?: number | null, connectedBy?: { name?: string | null } | null } }> | null } | null, sent?: { edges?: Array<{ node: { workspaceId: string, workspaceName: string, workspaceLogo: string, icon?: string | null, workspaceURI: string, connectedAt?: string | null, connectionId: string, requestedAt: string, sharedItemsCount?: number | null, connectedBy?: { name?: string | null } | null } }> | null } | null, pending?: { edges?: Array<{ node: { workspaceId: string, workspaceName: string, workspaceLogo: string, icon?: string | null, workspaceURI: string, connectedAt?: string | null, connectionId: string, sharedItemsCount?: number | null, connectedBy?: { name?: string | null } | null } }> | null } | null } };


export const SharedConnectionsDocument = /*#__PURE__*/ gql`
    query sharedConnections($filters: SharedConnectionsFilters) {
  sharedConnections(filters: $filters) {
    active {
      edges {
        node {
          workspaceId
          workspaceName
          workspaceLogo
          icon
          workspaceURI
          connectedAt
          connectionId
          sharedItemsCount
          connectedBy {
            name
          }
        }
      }
    }
    sent {
      edges {
        node {
          workspaceId
          workspaceName
          workspaceLogo
          icon
          workspaceURI
          connectedAt
          connectionId
          requestedAt
          sharedItemsCount
          connectedBy {
            name
          }
        }
      }
    }
    pending {
      edges {
        node {
          workspaceId
          workspaceName
          workspaceLogo
          icon
          workspaceURI
          connectedAt
          connectionId
          sharedItemsCount
          connectedBy {
            name
          }
        }
      }
    }
  }
}
    `;

export function useSharedConnectionsQuery(options?: Omit<Urql.UseQueryArgs<SharedConnectionsQueryVariables>, 'query'>) {
  return Urql.useQuery<SharedConnectionsQuery, SharedConnectionsQueryVariables>({ query: SharedConnectionsDocument, ...options });
};